
export const tipoDeViviendaMockupData = [
  {
    id: 1,
    nombre: "PEQUEÑA",
  },
  {
    id: 2,
    nombre: "MEDIANA",
  },
  {
    id: 3,
    nombre: "GRANDE",
  }
];

export const tipoNumeroDeCutoasMockupData = [
  {
    id: 1,
    nombre: "1",
  },
  {
    id: 2,
    nombre: "2",
  },
  {
    id: 3,
    nombre: "3",
  },
  {
    id: 4,
    nombre: "4",
  },
  {
    id: 5,
    nombre: "5",
  },
  {
    id: 6,
    nombre: "6",
  }
];


export const servicioCorreoData = [
  '@gmail.com', '@outlook.com', '@hotmail.com', '@yahoo.com', '@icloud.com', '@protonmail.com', '@aol.com', '@zoho.com', 'INGRESAR MANUALMENTE'
]

export const parentescoMockupData = [
  {
    id_entidad: 1,
    nombre: "PADRE",
  },
  {
    id_entidad: 2,
    nombre: "MADRE",
  },
  {
    id_entidad: 3,
    nombre: "HIJO/A",
  },
  {
    id_entidad: 4,
    nombre: "HERMANO/A",
  },
  {
    id_entidad: 5,
    nombre: "PRIMO/A",
  },
  {
    id_entidad: 6,
    nombre: "TIO/A",
  },
  {
    id_entidad: 7,
    nombre: "OTRO",
  },
]

export interface IParentesco {
  id_entidad: number;
  nombre: string;
}


export const comoSeEnteroMockupData = [
  {
    nombre: "BUSES"
  },
  {
    nombre: "CAMPAÑA WHATSAPP"
  },
  {
    nombre: "CLIENTE ACTIVO - NUEVO CONTRATO"
  },
  {
    nombre: "EVENTOS/ACTIVICACIONES"
  },
  {
    nombre: "FACEBOOK"
  },
  {
    nombre: "GOOGLE ADS"
  },
  {
    nombre: "INSTAGRAM"
  },
  {
    nombre: "PÁGINA WEB"
  },
  {
    nombre: "POSTES"
  },
  {
    nombre: "PUNTO DE VENTA"
  },
  {
    nombre: "RADIO"
  },
  {
    nombre: "REFERIDOS"
  },
  {
    nombre: "TELEVISIÓN"
  },
  {
    nombre: "TIK TOK"
  },
  {
    nombre: "VALLAS PUBLICITARIAS"
  },
  {
    nombre: "VENDEDORES EXTERNOS"
  },
  {
    nombre: "VENTAS CONJUNTOS"
  },
  {
    nombre: "VENTAS MASIVAS"
  },
  {
    nombre: "VOLANTEO/ PUERTA A PUERTA"
  },

];

export const herramientaUtilizadaMockupData = [
  {
    nombre: "CENTRAL TELEFÓNICA"
  },
  {
    nombre: "FORMULARIOS"
  },
  {
    nombre: "FORMULARIOS INSTAGRAM"
  },
  {
    nombre: "ISLA CCR (ISLA CENTRO COMERCIAL RECREO)"
  },
  {
    nombre: "ISLA C.C. FORTÍN"
  },
  {
    nombre: "MENSAJERIA INSTAGRAM"
  },
  {
    nombre: "MESSENGER"
  },
  {
    nombre: "PRESENCIAL (OFICINA)"
  },
  {
    nombre: "VENDEDORES EXTERNOS"
  },
  {
    nombre: "WHATSAPP BUSINESS"
  },
]

export const numerosMockupData = [
  {
    nombre: "1"
  },
  {
    nombre: "2"
  },
  {
    nombre: "3"
  },
  {
    nombre: "4"
  },
  {
    nombre: "5"
  },
  {
    nombre: "MAS DE 6"
  },
]

export const estadosProspectoMockupData = [
  {
    codigo: 1,
    nombre: "ESPERA"
  },
  {
    codigo: 2,
    nombre: "DISPONIBLE"
  },
  {
    codigo: 3,
    nombre: "REALIZADO"
  },
  {
    codigo: 4,
    nombre: "RECHAZADO"
  }
]

export const estadosPreventaMockupData = [
  {
    codigo: 1,
    nombre: "EN ESPERA"
  },
  {
    codigo: 2,
    nombre: "PREAGENDADO"
  },
  {
    codigo: 3,
    nombre: "REALIZADO"
  },
  {
    codigo: 4,
    nombre: "RECHAZADO"
  }
]

export const respBuroCredio = {
  data: {
    segmentacion: 'RECHAZAR',
    puntaje_score_empresa: 200,
    puntaje_score: 200,
    puntaje_score_sobreendeudamiento: 200,
  }
}


export const mockupDataProductoFibra = {
  "id": "6886ab1d-4331-4854-b789-3bc9c1b877f6",
  "codigo": "MFO.015.0082",
  "cantidad": "1",
  "producto_data": {
    "codigo": "MFO.015.0082",
    "categoria_producto": "MATERIALES DE FIBRA OPTICA",
    "descripcion": "FIBRA PLANA 1 HILOS 2000MT GJYXFCH-2B6 G.657A2",
    "stock_actual": "213.0000",
    "modelo_producto": "MODELO-PRUEBA",
    "marca_producto": "MARCA-PRUEBA",
    "unidad_medida": "UNIDADES",
    "presentacion": "PRESENTACION-PRUEBA",
    "productos_asociados": []
  },
  "metros_actuales": "1612099.00",
  "contiene_serie": true,
  "series": [],
  "usa_metros": true,
  "ubicacion_origen": "d7d5e06a-f068-4e67-9522-ccd647619b20"
}

export const mockupDataEstadoInstalacionSofnet = {
  "code": 200,
  "status": "success",
  "message": "Consulta realizada correctamente",
  "data": {
    "id_inst": 121454,
    "nombre_cliente": "PEREZ LOPEZ GLADYS FABIOLA_1",
    "estado_venta": "OK",
    "estado_instalacion": "OK"
  }
} 